import { getProductId } from './../../../order-builder/modules/specification/helpers/product.helper';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, take, map } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickSelectProductsAction } from '../../actions/one-click-products.actions';
import { State } from '../../reducers';
import { getOneClickProducts } from './../../selectors/one-click-products.selector';

@Injectable()
export class OneClickSyncProduct implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOneClickProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => getProductId(product) === value)),
      )
      .subscribe((product) => {
        if (product) {
          this.store.dispatch(new OneClickSelectProductsAction(product, form.mapItem['index']));
        }
      });
  }
}
